// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
'use es6';

export var PANEL_NAVIGATOR_TRANSITION_TIMING = '400ms';
export var CARD_TRANSITION_ANIMATION_TIMING = '200ms';
export var TABS_ACTIVATE_TRANSITION_TIMING = '200ms';
export var NAV_LIST_TRANSITION_ANIMATION_TIMING = '200ms';
export var MICRO_TRANSITION_TIMING = '150ms';
export var EDITABLE_CONTROLS_TRANSITION_TIMING = '250ms';
export var DEFAULT_MODAL_TRANSITION_TIMING = '350ms';
export var SLIDEIN_MODAL_TRANSITION_TIMING = '300ms';
export var PANEL_TRANSITION_TIMING = '150ms';
export var MODAL_BACKGROUND_TRANSITION_TIMING = '100ms';
export var HOVERLAY_TRANSITION_TIMING = '200ms';
export var FLOATING_ALERT_TIMING = '300ms';
export var POPOVER_TRANSITION_TIMING = '200ms';
export var FLOATING_ALERT_DEFAULT_TIMING = '4000ms';